(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_look"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stl-look')) {
    /**
     * Shop the look: tick boxes, size chips, single adds and the full look add. Uses the theme's
     * CartAddEvent so the cart bubble, cart items and cart drawer (when enabled) refresh the same
     * way as the product form. Dispatches `stl:look-state` so the page's sticky bar can mirror it.
     */
    class StlLook extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        this.addEventListener('submit', this.#onSubmit, { signal });
        this.addEventListener('click', this.#onClick, { signal });
        this.addEventListener('change', this.#onChange, { signal });
        this.querySelector('[data-stl-slides]')?.addEventListener('scroll', this.#onSlide, { signal, passive: true });
        this.#startVideo();
        this.#render();
      }

      disconnectedCallback() {
        this.#abort?.abort();
        this.#abort = null;
      }

      /** Current state for the sticky bar. */
      get state() {
        return this.#state();
      }

      /** Adds every ticked item, or points to the first missing size. */
      addLook() {
        const button = this.querySelector('[data-stl-full-look]');
        if (button instanceof HTMLButtonElement) this.#addFullLook(button);
      }

      #startVideo() {
        const video = this.querySelector('video[data-stl-autoplay]');
        if (!(video instanceof HTMLVideoElement)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.controls = true;
          return;
        }
        video.play().catch(() => {
          video.controls = true;
        });
      }

      #onSlide = () => {
        const slides = this.querySelector('[data-stl-slides]');
        if (!(slides instanceof HTMLElement)) return;
        const index = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
        this.querySelectorAll('.stl-look__dot').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };

      /** @param {Event} event */
      #onSubmit = (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-stl-item')) return;
        event.preventDefault();

        if (this.#isMissingSize(form)) {
          this.#setRowError(form, true);
          this.#focusSizes(form);
          return;
        }

        const id = new FormData(form).get('id');
        const button = form.querySelector('[data-stl-add]');
        if (!id || !(button instanceof HTMLButtonElement)) return;
        this.#add([{ id: Number(id), quantity: 1 }], button, this.dataset.textAdded || '');
      };

      /** @param {Event} event */
      #onClick = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        const button = target.closest('[data-stl-full-look]');
        if (button instanceof HTMLButtonElement) this.#addFullLook(button);
      };

      /** @param {Event} event */
      #onChange = (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement)) return;
        const form = input.closest('form');
        if (form && (input.type === 'radio' || !input.checked)) this.#setRowError(form, false);
        this.#render();
      };

      /** @param {HTMLButtonElement} button */
      #addFullLook(button) {
        const state = this.#state();
        if (state.firstMissing) {
          for (const form of state.missingForms) this.#setRowError(form, true);
          this.#announce(this.dataset.textMissingSizes || '', true);
          this.#focusSizes(state.firstMissing, true);
          return;
        }
        if (!state.items.length) return;
        this.#add(state.items, button, this.dataset.textFullLookAdded || '');
      }

      #forms() {
        return [...this.querySelectorAll('form[data-stl-item]')].filter(
          (form) => form instanceof HTMLFormElement && form.dataset.soldOut !== 'true'
        );
      }

      #state() {
        const forms = this.#forms();
        /** @type {HTMLFormElement[]} */
        const missingForms = [];
        const items = [];
        let ticked = 0;
        let total = 0;

        for (const form of forms) {
          const include = form.querySelector('[data-stl-include]');
          if (include instanceof HTMLInputElement && !include.checked) continue;
          ticked += 1;
          const checked = form.querySelector('[data-stl-size] input:checked');
          const price = checked instanceof HTMLInputElement ? checked.dataset.price : form.dataset.price;
          total += Number(price) || 0;
          if (this.#isMissingSize(form)) {
            missingForms.push(form);
            continue;
          }
          const id = new FormData(form).get('id');
          if (id) items.push({ id: Number(id), quantity: 1 });
        }

        const missing = missingForms.length;
        let label = '';
        if (ticked === 0) label = this.dataset.textNone || '';
        else if (missing === 1) label = this.dataset.textSelectOne || '';
        else if (missing > 1) label = (this.dataset.textSelectOther || '').replace('[count]', String(missing));
        else if (ticked === forms.length) label = this.dataset.textAddLook || '';
        else if (ticked === 1) label = this.dataset.textAddOne || '';
        else label = (this.dataset.textAddOther || '').replace('[count]', String(ticked));

        return {
          name: this.dataset.lookName || '',
          label,
          total: this.#formatMoney(total),
          ticked,
          items,
          missingForms,
          firstMissing: missingForms[0] || null,
        };
      }

      #render() {
        const state = this.#state();
        const button = this.querySelector('[data-stl-full-look]');
        const label = this.querySelector('[data-stl-full-label]');
        const total = this.querySelector('[data-stl-full-total]');
        if (label) label.textContent = state.label;
        if (total) total.textContent = state.total;
        if (button instanceof HTMLButtonElement) button.disabled = state.ticked === 0;
        this.dispatchEvent(new CustomEvent('stl:look-state', { bubbles: true, detail: state }));
      }

      /** @param {number} cents */
      #formatMoney(cents) {
        const holder = this.querySelector('[data-stl-money-format]');
        const template = (holder instanceof HTMLTemplateElement ? holder.content.textContent : '')?.trim() || '';
        const zeroDecimal = ['JPY', 'KRW', 'VND', 'CLP', 'ISK', 'HUF', 'TWD'];
        // Matches money placeholders such as amount_no_decimals between double braces.
        const placeholder = new RegExp('\\{\\{\\s*(\\w+)\\s*\\}\\}', 'g');
        if (!template) return (cents / 100).toFixed(2);
        return template.replace(placeholder, (_, name) => {
          let precision = zeroDecimal.includes((this.dataset.currency || '').toUpperCase()) ? 0 : 2;
          let thousands = ',';
          let decimal = '.';
          if (name.includes('no_decimals')) precision = 0;
          if (name.includes('comma_separator')) [thousands, decimal] = ['.', ','];
          if (name.includes('space_separator')) thousands = ' ';
          if (name.includes('apostrophe')) thousands = "'";
          const [whole, fraction] = (cents / 100).toFixed(precision).split('.');
          const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return fraction ? `${grouped}${decimal}${fraction}` : grouped;
        });
      }

      /** @param {HTMLFormElement} form */
      #isMissingSize(form) {
        const group = form.querySelector('[data-stl-size]');
        return Boolean(group && !group.querySelector('input:checked'));
      }

      /**
       * @param {HTMLFormElement} form
       * @param {boolean} [scroll]
       */
      #focusSizes(form, scroll = false) {
        const first = form.querySelector('[data-stl-size] input:enabled');
        if (!(first instanceof HTMLInputElement)) return;
        if (scroll) {
          const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          form.scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
          first.focus({ preventScroll: true });
        } else {
          first.focus();
        }
      }

      /**
       * @param {HTMLFormElement} form
       * @param {boolean} invalid
       */
      #setRowError(form, invalid) {
        const group = form.querySelector('[data-stl-size]');
        const error = form.querySelector('[data-stl-error]');
        if (group) group.setAttribute('aria-invalid', String(invalid));
        if (error instanceof HTMLElement) error.hidden = !invalid;
      }

      /**
       * @param {Array<{id: number, quantity: number}>} items
       * @param {HTMLButtonElement} button
       * @param {string} successText
       */
      async #add(items, button, successText) {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');

        const sectionIds = [...document.querySelectorAll('cart-items-component')]
          .map((element) => element instanceof HTMLElement && element.dataset.sectionId)
          .filter(Boolean);
        const body = { items };
        if (sectionIds.length) body.sections = sectionIds.join(',');

        try {
          const response = await fetch(this.dataset.cartAddUrl || '', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
            signal: this.#abort?.signal,
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || '');
          }

          this.dispatchEvent(await this.#cartEvent(items, data.sections));
          this.#announce(successText, false, true);
        } catch (error) {
          if (error instanceof DOMException && error.name === 'AbortError') return;
          const message = error instanceof Error && error.message ? error.message : '';
          this.#announce(message || this.dataset.textError || '', true);
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      /**
       * @param {Array<{id: number, quantity: number}>} items
       * @param {Record<string, string> | undefined} sections
       */
      async #cartEvent(items, sections) {
        const data = {
          source: 'product-form-component',
          itemCount: items.length,
          variantId: String(items[0].id),
          sections,
        };
        try {
          const { CartAddEvent } = await import('@theme/events');
          return new CartAddEvent({}, this.id, data);
        } catch {
          return new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: this.id, data } });
        }
      }

      /**
       * @param {string} message
       * @param {boolean} isError
       * @param {boolean} [withCartLink]
       */
      #announce(message, isError, withCartLink = false) {
        const status = this.querySelector('[data-stl-status]');
        if (!(status instanceof HTMLElement)) return;
        status.classList.toggle('is-error', isError);
        status.replaceChildren(document.createTextNode(message));
        if (withCartLink && this.dataset.cartUrl) {
          const link = document.createElement('a');
          link.href = this.dataset.cartUrl;
          link.textContent = this.dataset.textViewBag || '';
          status.append(link);
        }
      }
    }

    customElements.define('stl-look', StlLook);
  }
  } catch(e) { console.error(e); }
})();

})();
